import InfoIcon from "@/components/atoms/svg/icons/InfoIcon";

interface IErrorStateProps {
  message?: string | undefined;
}

export default function ErrorState(props: IErrorStateProps) {
  return (
    <div className="text-sm text-destructive mt-2 flex items-center space-x-1">
      <InfoIcon />
      <span>{props.message}</span>
    </div>
  );
}
